<app-header
  (updateExpensiveEndgameCostEvent)="onUpdateEndgameCost($event)"
  (updateLocaleEvent)="onUpdateLocale($event)"
  (updateWhiteTigerRecipesEvent)="onUpdateWhiteTigerRecipes($event)"
  (updateResourceCostMultiplierEvent)="onUpdateResourceCostMultiplier($event)"
  [imageBaseUrl]="imageBaseUrl"
></app-header>

<div class="container-fluid top-padding bottom-margin">
  <app-crafting-parent [imageBaseUrl]="imageBaseUrl"
                       [imageTemplateUrl]="imageTemplateUrl">
  </app-crafting-parent>
</div>

<app-footer></app-footer>
